import { lazy } from 'react';

export async function loader(args) {
  const load = await import('./loader');
  return load.default(args);
}

export const Page = lazy(() => import('./page'));
